import constants, { ACCESS_TOKEN, HTTP_METHODS } from "../../../settings/shared/constants";
import axiosClient from "../../common";

function _constructHeader() {
  return {
    "Content-Type": "application/json",
    Authorization: "Bearer " + localStorage.getItem(ACCESS_TOKEN),
  };
}

/**
 * Full list: GET api/governance/audits
 * Filtered:  GET api/governance/audits?jobType=WORKFLOW&jobId=...&decision=...
 */
function listAudits(filters = {}) {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value == null) return;
    const text = String(value).trim();
    if (!text) return;
    params.set(key, text);
  });
  const query = params.toString();
  return axiosClient({
    url: query ? `${constants.api.governance.audits}?${query}` : constants.api.governance.audits,
    method: HTTP_METHODS.GET,
    headers: _constructHeader(),
  });
}

const GovernanceService = {
  listAudits,
};

export default GovernanceService;
